// import moment from "moment";
// import React from "react";
// import formatDateDDMMYYYY from "../../../../Main/formatDate";
// import UserCurrency from "../../../../Componets/UserCurrency";

// const ThermalInvoice = React.forwardRef((props, ref) => {
//   const { values } = props;

//   return (
//     <div ref={ref} style={styles.invoice}>
//       <div style={styles.header}>
//         <h2 className="text-base">{values?.branch?.name}</h2>
//         <p>{values?.branch?.area}</p>
//         <p>
//           {values?.branch?.city ? values?.branch?.city + ", " : ""}
//           {values?.branch?.state}
//         </p>
//         <p>{values?.branch?.country}</p>
//         <p>PHONE : {values?.branch?.phone}</p>
//         <p>EMAIL : {values?.branch?.email}</p>
//         <p>VATIN : {values?.branch?.tax}</p>
//       </div>
//       <div style={styles.details}>
//         <p>Invoice : {`#INV-${values?.number}`}</p>
//         <p>
//           Customer :
//           {values?.customer?.name ? values?.customer?.name : "Walk-in-customer"}
//         </p>
//         <p>Phone :{values?.customer?.phone ? values?.customer?.phone : ""}</p>
//         <p>Date:{formatDateDDMMYYYY(values?.date)}</p>
//       </div>
//       <div className="mb-2 border-t border-dashed border-black" />
//       <div style={styles.items}>
//         <table style={styles.table}>
//           <thead>
//             <tr className="border-b border-dashed border-black">
//               <th className="p-1" style={styles.th}>
//                 Item
//               </th>
//               <th className="p-1" style={styles.th}>
//                 Unit
//               </th>
//               <th className="p-1" style={styles.th}>
//                 QTY
//               </th>
//               <th className="p-1" style={styles.th}>
//                 PRC
//               </th>
//               <th className="px-1" style={styles.th}>
//                 TAX
//               </th>
//               <th className="p-1" style={styles.th}>
//                 Total
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {values?.details?.map((item, index) => (
//               <React.Fragment>
//                 <tr key={index}>
//                   <td className="p-1" style={styles.td} colSpan={5}>
//                     <div>{item?.name}&nbsp;</div>
//                     <div>#BATCH-{item?.description?.number}</div>
//                     <div>
//                       {item?.description?.expiry_date
//                         ? "Expiry : " +
//                           formatDateDDMMYYYY(item?.description?.expiry_date)
//                         : ""}
//                     </div>
//                   </td>
//                 </tr>
//                 <tr key={index}>
//                   <td colSpan={1}></td>
//                   <td className="p-1" style={styles.td}>
//                     {item?.unit_name}
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     &nbsp;{item?.quantity?.toFixed(3)}
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     <div>{item?.sale_price?.toFixed?.(3)}</div>
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     <div>{item?.tax}%</div>
//                     {/* <div>{item?.tax_amount?.toFixed?.(3)}</div> */}
//                   </td>
//                   <td className="p-1" style={styles.td}>
//                     &nbsp;{item?.total?.toFixed?.(3)}
//                   </td>
//                 </tr>
//               </React.Fragment>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div className="mb-2 border-t border-dashed border-black" />
//       <div
//         style={styles?.total}
//         className="pr-2 border-t border-dashed border-black pt-2"
//       >
//         <p>Subtotal: {values?.subtotal?.toFixed(3)}</p>
//         <p>Taxamount: {values?.taxamount?.toFixed(3)}</p>
//         <p>
//           Discount:
//           {values?.discount ? "-" + values?.discount?.toFixed(3) : "0.000"}
//         </p>
//         <p>
//           Delivery:
//           {values?.delivery ? "+" + values?.delivery?.toFixed(3) : "0.000"}
//         </p>
//         <h3 className="text-medium">
//           Total: <UserCurrency />&nbsp;{values?.total?.toFixed(3)}
//         </h3>
//       </div>
//       <div className="mt-2 border-t border-dashed border-black" />
//       <div className="mt-2 border-t border-dashed border-black" />
//     </div>
//   );
// });

// const styles = {
//   invoice: {
//     width: "100%",
//     width: "80mm", // Typical width for thermal printers
//     fontFamily: "monospace",
//     fontSize: "12px",
//     padding: "10px",
//     // border: "1px solid #000",
//   },
//   header: {
//     textAlign: "center",
//     marginBottom: "10px",
//   },
//   details: {
//     marginBottom: "10px",
//   },
//   items: {
//     marginBottom: "10px",
//   },
//   table: {
//     width: "100%",
//     borderCollapse: "collapse",
//   },
//   th: {
//     // borderBottom: "1px solid #000",
//     // borderStyle: "dotted",
//     textAlign: "left",
//   },
//   td: {
//     padding: "5px 0",
//   },
//   total: {
//     textAlign: "right",
//   },
// };

// export default ThermalInvoice;

import React from "react";
import formatDateDDMMYYYY from "../../../../Main/formatDate";
import UserCurrency from "../../../../Componets/UserCurrency";

const ThermalInvoice = React.forwardRef((props, ref) => {
  const { values } = props;

  const infoRow = (label, value) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
        lineHeight: 1.25,
      }}
    >
      <span>{label}:</span>
      <span>{value}</span>
    </div>
  );

  return (
    <div
      ref={ref}
      style={{
        ...styles.invoice,
        fontFamily: "Arial, Helvetica, sans-serif",
        WebkitPrintColorAdjust: "exact",
        printColorAdjust: "exact",
      }}
    >
      {/* HEADER */}
      <div style={styles.header}>
        <h2
          style={{
            margin: "0 0 2px 0",
            fontSize: "13px",
            fontWeight: 700,
            lineHeight: 1.2,
          }}
        >
          {values?.branch?.name}
        </h2>

        <div
          style={{
            margin: "1px 0",
            fontSize: "10px",
            lineHeight: 1.3,
          }}
        >
          VATIN: {values?.branch?.tax || "—"}
        </div>

        <p
          style={{
            margin: "1px 0",
            fontSize: "10px",
            lineHeight: 1.25,
          }}
        >
          {[
            values?.branch?.area,
            values?.branch?.city,
            values?.branch?.state,
            values?.branch?.country,
          ]
            .filter(Boolean)
            .join(", ")}
        </p>

        <p
          style={{
            margin: "2px 0",
            fontSize: "10px",
          }}
        >
          PHONE: {values?.branch?.phone || "—"}
        </p>

        {values?.branch?.email && (
          <p
            style={{
              margin: "2px 0",
              fontSize: "10px",
            }}
          >
            EMAIL: {values?.branch?.email}
          </p>
        )}

        <p
          style={{
            margin: "4px 0 0",
            fontSize: "10.5px",
            fontWeight: 700,
          }}
        >
          TAX INVOICE
        </p>
      </div>

      <div className="my-1 border-t border-dashed border-black" />

      {/* INVOICE DETAILS */}
      <div
        style={{
          marginBottom: "6px",
          fontSize: "9px",
        }}
      >
        {infoRow(
          "Invoice No",
          `#INV-${values?.number}`
        )}

        {infoRow(
          "Date",
          formatDateDDMMYYYY(values?.date)
        )}

        {infoRow(
          "Customer",
          values?.customer?.name || "Walk-in Customer"
        )}

        {infoRow(
          "Phone",
          values?.customer?.phone || "—"
        )}

        {infoRow(
          "Payment Mode",
          values?.payments?.name || "—"
        )}
      </div>

      <div className="my-1 border-t border-dashed border-black" />

      {/* ITEMS */}
      <div style={styles.items}>
        <table
          style={{
            ...styles.table,
            tableLayout: "fixed",
          }}
        >
          <thead>
            <tr
              className="border-b border-dashed border-black"
              style={{
                fontSize: "8px",
                lineHeight: 1.2,
              }}
            >
              <th
                style={{
                  textAlign: "left",
                  width: "34%",
                }}
              >
                Item
              </th>

              <th
                style={{
                  textAlign: "right",
                  width: "12%",
                }}
              >
                Unit
              </th>

              <th
                style={{
                  textAlign: "right",
                  width: "12%",
                }}
              >
                QTY
              </th>

              <th
                style={{
                  textAlign: "right",
                  width: "16%",
                }}
              >
                Price
              </th>

              <th
                style={{
                  textAlign: "right",
                  width: "10%",
                }}
              >
                Tax
              </th>

              <th
                style={{
                  textAlign: "right",
                  width: "16%",
                }}
              >
                Total
              </th>
            </tr>
          </thead>

          <tbody>
            {values?.details?.map((item, index) => (
              <React.Fragment key={index}>
                {/* ITEM */}
                <tr>
                  <td
                    colSpan={6}
                    style={{
                      ...styles.td,
                      padding: "4px 2px 0",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "8.5px",
                        lineHeight: 1.2,
                      }}
                    >
                      {item?.name}
                    </div>

                    {item?.description?.number && (
                      <div
                        style={{
                          fontSize: "7px",
                          lineHeight: 1.2,
                        }}
                      >
                        #BATCH-{item.description.number}
                      </div>
                    )}

                    {item?.description?.expiry_date && (
                      <div
                        style={{
                          fontSize: "7px",
                          lineHeight: 1.2,
                        }}
                      >
                        Expiry:{" "}
                        {formatDateDDMMYYYY(
                          item.description.expiry_date
                        )}
                      </div>
                    )}
                  </td>
                </tr>

                {/* ITEM VALUES */}
                <tr>
                  <td
                    style={{
                      ...styles.td,
                      padding: "0 2px 2px",
                    }}
                  />

                  <td
                    style={{
                      ...styles.td,
                      textAlign: "right",
                      fontSize: "8px",
                      padding: "0 2px 2px",
                    }}
                  >
                    {item?.unit_name || "—"}
                  </td>

                  <td
                    style={{
                      ...styles.td,
                      textAlign: "right",
                      fontSize: "8px",
                      padding: "0 2px 2px",
                    }}
                  >
                    {Number(item?.quantity || 0).toFixed(3)}
                  </td>

                  <td
                    style={{
                      ...styles.td,
                      textAlign: "right",
                      fontSize: "8px",
                      padding: "0 2px 2px",
                    }}
                  >
                    {Number(item?.sale_price || 0).toFixed(3)}
                  </td>

                  <td
                    style={{
                      ...styles.td,
                      textAlign: "right",
                      fontSize: "8px",
                      padding: "0 2px 2px",
                    }}
                  >
                    {Number(item?.tax || 0)}%
                  </td>

                  <td
                    style={{
                      ...styles.td,
                      textAlign: "right",
                      fontSize: "7.5px",
                      padding: "0 2px 2px",
                    }}
                  >
                    {Number(item?.total || 0).toFixed(3)}
                  </td>
                </tr>

                {index <
                  (values?.details?.length || 0) - 1 && (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ height: "5px" }}
                      />
                    </tr>
                  )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      <div className="my-2 border-t border-dashed border-black" />

      {/* TOTALS */}
      <div
        style={{
          textAlign: "right",
          fontSize: "10px",
          lineHeight: 1.4,
        }}
      >
        {infoRow(
          "Subtotal",
          Number(values?.subtotal || 0).toFixed(3)
        )}

        {infoRow(
          "Tax Amount",
          Number(values?.taxamount || 0).toFixed(3)
        )}

        {values?.discount > 0 &&
          infoRow(
            "Discount",
            `-${Number(values.discount).toFixed(3)}`
          )}

        {values?.delivery > 0 &&
          infoRow(
            "Delivery",
            `+${Number(values.delivery).toFixed(3)}`
          )}

        <hr
          style={{
            margin: "5px 0",
            border: 0,
            borderTop: "1px solid #000",
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "12px",
            fontWeight: 700,
          }}
        >
          <span>Grand Total</span>

          <span>
            <UserCurrency />{" "}
            {Number(values?.total || 0).toFixed(3)}
          </span>
        </div>
      </div>

      {/* FOOTER */}
      <div
        style={{
          marginTop: "10px",
          textAlign: "center",
          fontSize: "9px",
          lineHeight: 1.4,
        }}
      >
        Thank you for shopping with us
      </div>
    </div>
  );
});

const styles = {
  invoice: {
    width: "80mm",
    maxWidth: "80mm",
    boxSizing: "border-box",
    fontSize: "10.5px",
    lineHeight: 1.35,
    padding: "8px 7px",
    color: "#000",
    backgroundColor: "#fff",
  },

  header: {
    textAlign: "center",
    marginBottom: "6px",
  },

  items: {
    marginBottom: "6px",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  td: {
    padding: "2px 2px",
    verticalAlign: "top",
    lineHeight: 1.2,
  },
};

export default ThermalInvoice;